import axios from "axios";
import { apiURL } from "./constants";
import { useContext } from 'react';
import { LoadingContext } from "../context/LoadingContext";
import { isPendingApproval403Detail } from "../utils/customerAccountApproval";

let refresh = false;
axios.interceptors.response.use(resp => resp, async error => {
    const res = error.response;
    if (res && res.status === 403 && isPendingApproval403Detail(res.data && res.data.detail)) {
        window.dispatchEvent(new CustomEvent('gofar:customer-account-inactive'));
        refresh = false;
        return Promise.reject(error);
    }
    if (res && res.status === 401 && !refresh && res.data && res.data.detail != "No active account found with the given credentials") {
        refresh = true;
        console.log(localStorage.getItem('refresh_token'))
        const response = await
            axios.post(`${apiURL}/auth/refresh/`, {
                refresh: localStorage.getItem('refresh_token')
            }, {
                headers:
                    { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.status === 200) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${response.data['access']}`;
            localStorage.setItem('access_token', response.data.access);
            localStorage.setItem('refresh_token', response.data.refresh);
            window.location.reload();
            // return axios(error.config);

        }
        if (response.status === 500) {
            window.location.href = '/ServerError';
        }
        else {
            window.location.href = '/Login';
        }
    }
    refresh = false;
    // Reject so 4xx/5xx (and no-response failures) are not treated as success in .then/await
    return Promise.reject(error);
});


// src/api/axios.js


const axiosInstance = axios.create({
    baseURL: apiURL, // Replace with your base URL
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true
});

// Create a hook to access the loading context
export const useAxiosInterceptors = () => {
    const { setLoading } = useContext(LoadingContext);

    axiosInstance.interceptors.request.use(
        config => {
            setLoading(true);
            const token = localStorage.getItem('token');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        error => {
            setLoading(false);
            return Promise.reject(error);
        }
    );

    axiosInstance.interceptors.response.use(
        response => {
            setLoading(false);
            return response;
        },
        error => {
            setLoading(false);
            if (error.response && error.response.status === 401) {
                // Handle unauthorized access
            }
            return Promise.reject(error);
        }
    );
};

export default axiosInstance;